import {dateFormatServer, dpParseDate, secondsToTime, timeToSeconds} from '../filters'
import BaseModel from './baseModel'

export default class Reel extends BaseModel {
  digitazion = {
    data: {
      digiters: {},
      faultAnalyzers: {}
    }
  }
  restoration = {
    data: {
      filmAnalyzers: {},
      restorers: {}
    }
  }
  description = {
    data: {
      filmPersons: {},
      places: {},
      // keywords: {}
      macrotags: {},
      microtags: {}
    }
  }
  filmFormats = {}
  filmBrands = {}
  reelimages = {}

  constructor (create, data, user) {
    super()
    if (create) {
      this.restoration.data.sindrome_aceto = 0
      this.restoration.data.sporco = 2
      this.digitazion.data.restringimento = 0
      this.restoration.data.colore_decaduto = 0
      this.restauro = 0
      this.digitazion.data.freq1 = 1
      this.digitazion.data.velocita = 1
      this.digitazion.data.note = this.emptyNote
      this.digitazion.data.difetti_note = this.emptyNote
      this.note = this.emptyNote
      this.restoration.data.audio_note = this.emptyNote
      this.restoration.data.note = this.emptyNote
      this.restoration.data.interventi_note = this.emptyNote
      this.restoration.data.filmAnalyzers.data = [user]
    }
    if (data !== undefined) {
      if (data.digitazion !== undefined) {
        data.digitazion.data.data = dpParseDate(data.digitazion.data.data)
      }
      if (data.restoration !== undefined) {
        data.restoration.data.data = dpParseDate(data.restoration.data.data)
        data.restoration.data.ult_rev_data = dpParseDate(data.restoration.data.ult_rev_data)
      }

      Object.entries(data).forEach(([key, value]) => {
        this[key] = value
      })
      this.durata = secondsToTime(this.durata)
    }
  }

  prepareForSend () {
    let data = _.cloneDeep(this)
    data.durata = timeToSeconds(data.durata)
    data.digitazion.data.data = dateFormatServer(data.digitazion.data.data)
    data.restoration.data.data = dateFormatServer(data.restoration.data.data)
    data.restoration.data.ult_rev_data = dateFormatServer(data.restoration.data.ult_rev_data)

    return data
  }

  prepareQueryForSearch () {
    return super.prepareQueryForSearch(this)
  }
}



// WEBPACK FOOTER //
// ./src/models/reel.js